<template>
    <section class="event_all_list_section">
        <div class="event_all_list_main">
            <router-link to="/" class="home_rdrtc_cross">
                <i aria-hidden="true" class="fa fa-times-circle-o mbl_cross"></i>
            </router-link>
            <div class="evnts_list_content_wrp">
                <h1 class="evnts_list_main_heading">Our Events</h1>
                <p class="evnts_list_main_subheading">Welcome to Lymphomap's Event Page</p>
                <div class="evnts_list_box_content" v-if="ourEventData">
                    <div class="row">
                        <div class="col-sm-3" v-for="(item, index) in ourEventResults" :key="index">
                            <div class="evnt_content_box">
                                <router-link :to="{ name: 'eventInfo', params: { evtId: item.id } }">
                                    <div class="evnt_thumb">
                                        <img :src="item.thumbnail" class="img-fluid">
                                    </div>
                                    <div class="evntinfo">
                                        <h3 class="evnt_name" :title="item.title">{{ item.title }}
                                        </h3>
                                        <div class="evnt_desgination" v-html="item.description"></div>
                                        <div class="evnt_published_date"><i class="fa fa-upload mr-1"></i>
                                            {{ item.datetime | LocalDateFormat }}</div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/*eslint-disable */
var $ = window.jQuery = require('jquery')

import { bus } from '@/main';
import carousel from 'vue-owl-carousel';

export default {
    name: 'vista-public-media-list',
    components: {
        carousel
    },
    props: [],
    data() {
        return {
            ourEventData: null,
            ourEventResults: []
        }
    },
    computed: {
    },
    mounted() {
        this.$store.dispatch('eventListAction').then((res) => {
            this.ourEventData = res.data
            this.ourEventResults = this.ourEventData.data
        })
    },
    methods: {
    },
    watch: {
    },
    beforeCreate: function () {
        $('body').addClass('dashboard')
    },
    beforeRouteLeave: function (to, from, next) {
        $('body').removeClass('dashboard')
        next();
    },
}
</script>

<style lang="scss" scoped>
.event_all_list_section {
    min-height: 100dvh;
    padding: 70px 10px 10px;

    .event_all_list_main {
        color: #ffffff;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
        letter-spacing: 1px;
        background: rgba(0, 0, 0, 0.75);
        min-height: calc(100dvh - 80px);
        position: relative;
    }

    .evnts_list_content_wrp {
        padding: 20px 30px;

        @media only screen and (max-width:767px) {
           padding: 10px;
        }

        .evnts_list_main_heading {
            color: #d29e00;
            font-size: 40px;
            margin-bottom: 5px;
            font-family: 'origin_tech_demoregular';
            line-height: 1;

            @media only screen and (max-width:767px) {
                font-size: 32px;
            }
        }

        .evnts_list_main_subheading {
            font-size: 14px;
            text-transform: capitalize;
            font-family: arial;
            color: #bbb;
            margin-bottom: 20px;
            line-height: 1;

            @media only screen and (max-width:767px) {
                margin-bottom: 15px;
                font-size: 13px;
            }
        }

        .evnts_list_box_content {
            .row {
                margin: 0 -7px;

                .col-sm-3 {
                    padding: 7px;
                }
            }
        }

        .evnt_content_box {
            background: linear-gradient(-30deg, rgba(37, 44, 84, 0.6) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(38, 38, 38, 0.6) 50%, rgba(44, 44, 84, 0.6) 100%);
            border: 1px solid rgba(93, 93, 93, 0.4);
            border-radius: 8px;
            text-align: left;
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            transition: all .5s ease;
            -webkit-transition: all .5s ease;
            -moz-transition: all ease .5s;
            transform-origin: center center;
            -webkit-transform-origin: center center;
            -moz-transform-origin: center center;

            &:hover {
                transform: scale(1.01);
                -webkit-transform: scale(1.01);
                -moz-transform: scale(1.01);
                .evnt_name {
                    color: #ffd400 !important;
                }
            }

            a {
                color: inherit;
                padding: 10px;
                display: block;
                text-decoration: none;
            }

            .evnt_thumb {
                height: 185px;
                overflow: hidden;

                .img-fluid {
                    width: 100%;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: center center;
                }
            }

            .evntinfo {
                margin-top: 8px;

                .evnt_name {
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 1.3;
                    margin: 0px 0px 5px;
                    font-family: 'BeonMedium';
                    height: 45px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: normal;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                    display: -webkit-box;
                    color: #87cefa;
                }

                .evnt_desgination {
                    font-size: 16px;
                    color: #d6d6d6;
                    font-family: 'georgiaregular';
                    line-height: 1.3;
                    margin-bottom: 5px;
                    height: 40px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: normal;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                    display: -webkit-box;
                }

                .evnt_published_date {
                    color: #747474;
                    font-size: 13px;
                    font-family: 'MyriadProRegular', 'Lato', sans-serif;
                }
            }
        }
    }

    .home_rdrtc_cross {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        z-index: 100;
        padding: 4px 10px;
        color: #e4002b;
        font-size: 28px;
        background-color: rgba(31, 31, 31, 0.5);
        border-radius: 5px;
        line-height: 1;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        border: 1px solid rgba(174, 182, 184, 0.1);
        overflow: hidden;
        display: inline-block;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(120deg,
                    transparent,
                    rgba(255, 255, 255, 0.2),
                    transparent);
            left: -100%;
            transition: all 0.65s ease-in-out;
        }

        &:hover {
            box-shadow: 1px 1px 25px 10px rgba(255, 255, 255, 0.5) !important;
            color: #ffd400;

            &::before {
                left: 100%;
            }
        }
    }

    .mobile_view_display {
        display: none !important;
    }

    @media only screen and (max-width:767px) {
        .mobile_view_display {
            display: block !important;
        }
    }
}
</style>